import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from "vue";
import {useRouter} from "vue-router";
import ModalDisplay from "@/components/ModalDisplay.vue";
import * as auth from "@/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const router = useRouter();
onMounted(async () => {
  await auth.restore();
  await router.isReady();
  if (!auth.hasRefreshToken()) {
    console.info("Not logged in, navigating to index");
    router.replace("/");
    return;
  }

  if (router.currentRoute.value.path === "/") {
    // If we are logged in navigate to home
    router.replace("/admin");
  }
});


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterView),
    _createVNode(ModalDisplay)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})